<template>
    <div style="width:100%">
         <el-select v-model="selectEmp" filterable remote  :remote-method="remoteMethod" clearable :loading="loading" @change="() => this.$emit('sync-select-employee', selectEmp)" 
             style="display:block;" :placeholder="$t('msg.fuzzyEmpSearch')" loading-text="loading..." :no-match-text="$t('msg.noDataFound')" :no-data-text="$t('msg.noDataFound')" :disabled="pOnlyView">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.label"></el-option>
        </el-select>
    </div>
</template>

<script>

import { apiFindHr } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {   
    props: {
      pSelectEmp: {
        type: String
      },
      pOnlyView: {
        type: Boolean,
        default: false
      }       
    },
    data() {
      return {
        options: [],
        loading: false,
        selectEmp:''
      }
    },
    watch:{
      pSelectEmp: function(){
        if(this.pSelectEmp == null || this.pSelectEmp ==''){
            this.selectEmp = '';
            this.options = [];
        }else{
          this.selectEmp = this.pSelectEmp;
        }
      } 
    },
    mounted(){
      if(this.pSelectEmp != null && this.pSelectEmp !=''){
        this.selectEmp = this.pSelectEmp;
      }
    },
    methods: {
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          apiFindHr({ headers: authHeader(), condition:query}).then((response) => {            
            this.options = [];
            var temp = [];
            response.data.forEach( function ( item, index, array)  {                
              temp.push({value:item.empNo, label: item.name+'('+item.empNo+')' });
            });
            this.options = temp; 
            this.loading = false;

          }).catch((err) => {
            console.log(err);
          });
        } else {
          this.options = [];
        }
      }
    }
}
</script>

<style scoped>
   
</style>